const Role = {
  queryList: [
    {
      name: 'roleName',
      label: '角色名称',
      component: 'input'
    }
  ],
  urlMap: {
    select: '/sys/role/list'
  },
  operList: [
    {
      name: 'add',
      label: '新增',
      show: true,
      action: {
        type: 'dialog',
        addr: 'systemManage/roleEdit'
      }
    }
  ],
  titles: [
    {
      name: 'roleName',
      label: '角色名称'
    },
    {
      name: 'accountType',
      label: '账号类型',
      map: {
        '1': '管理员',
        '2': '客服',
        '3': '一级送审单位',
        '4': '二级送审单位',
        '5': '专家',
        '6': '接收单位',
        '7': '财务'
      }
    },
    {
      name: 'createUserName',
      label: '创建者'
    },
    {
      name: 'remark',
      label: '备注'
    },
    {
      name: 'createTime',
      label: '创建时间'
    },
    {
      name: 'operation',
      label: '操作',
      actionList: [
        {
          label: '修改',
          kind: 'primary', // error
          type: 'dialog', // request, router, dialog, func
          addr: 'systemManage/roleEdit?{roleId}'
        }
      ]
    }
  ]
}
export default Role



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/systemManage/role.js